exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-content{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n.name-pointer{\r\n    cursor: pointer;\r\n}\r\n.status-block{\r\n    font-size: 10px;\r\n}\r\n\r\n.wrap {\r\n    background-color: white;\r\n    padding: 40px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/admin/my-created-standards/my-created-standards.component.css
// module id = ../../../../../src/app/content-page/admin/my-created-standards/my-created-standards.component.css
// module chunks = main